#import "../fragments/preference-center-audience-fragment.graphql"

query GetPublicAudience($id: ID!) {
    audience(id: $id) {
        ...PreferenceCenterAudience
    }
}
